<template>
  <!-- 商户信息管理，用于通联支付对接 -->
  <div class="">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="公告标题" @keydown.enter="resetSearch" clearable>
            <template #prefix>关键字</template>
          </el-input>
          <el-select v-model="searchInfo.searchType" placeholder="重要级别" @change="resetSearch" clearable>
            <template #prefix>重要级别</template>
            <el-option label="全部" value=""/>
            <el-option label="普通" :value="1"/>
            <el-option label="重要" :value="2"/>
            <el-option label="紧急" :value="3"/>
          </el-select>
          <el-select v-model="searchInfo.status" placeholder="状态" @change="resetSearch" clearable>
            <template #prefix>状态</template>
            <el-option label="全部" value=""/>
            <el-option label="草稿" :value="0"/>
            <el-option label="已发布" :value="1"/>
            <el-option label="已撤回" :value="-1"/>
          </el-select>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
          <page-button hasPerm="sys:message:saveDraft" type="write" el-type="success" @click="router.push(`/sys/message/detail`)">新建</page-button>
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border>
          <yq-table-column  label="公告标题" prop="messageTitle" min-width="180rem"/>
          <yq-table-column label="重要级别" prop="messageLevel">
            <template v-slot="{row}">
              <el-tag v-if="row.messageLevel === 1" type="info">普通</el-tag>
              <el-tag v-if="row.messageLevel === 2" type="warning">重要</el-tag>
              <el-tag v-if="row.messageLevel === 3" type="danger">紧急</el-tag>
            </template>
          </yq-table-column>
          <yq-table-column label="接收消息对象" prop="userCategoryType">
            <template v-slot="{row}">
              <span v-if="row.userCategoryType === 0"></span>
              <span v-if="row.userCategoryType === 1">全部</span>
              <span v-if="row.userCategoryType === 2">指定人员</span>
              <span v-if="row.userCategoryType === 3">指定角色</span>
              <span v-if="row.userCategoryType === 4">指定部门</span>
            </template>
          </yq-table-column>
          <yq-table-column label="状态" prop="messageStatus">
            <template v-slot="{row}">
              <el-tag v-if="row.messageStatus === 0" type="info">草稿</el-tag>
              <el-tag v-if="row.messageStatus === 1" type="success">已发布</el-tag>
              <el-tag v-if="row.messageStatus === -1" type="danger">已撤回</el-tag>
            </template>
          </yq-table-column>
          <yq-table-column label="发布时间" prop="publishTime"/>
          <yq-table-column  label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button @click="router.push(`/sys/message/detail?id=${row.id}`)">{{row.messageStatus === 0? '编辑': '查看'}}</table-button>
                <table-button has-perm="sys:message:revoke" @click="revoke(row)" :disabled="row.messageStatus !== 1" message="撤回通知将同步删除所有的提醒消息，是否确认返回">撤回</table-button>
                <table-button has-perm="sys:message:delete" el-type="danger" message="是否确认删除数据" @click="deleteData(row)">删除</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize" :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition";
import FormPage from "@/components/h5/layout/FormPage";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage";
import TableButton from "@/components/h5/button/TableButton";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import systemMessageApi from "@/api/normal/sys/systemMessageApi";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
    YqTableColumn, TableButtonGroup, TableButton, SearchCondition, FormPage, ListTable, ListPage
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    if (!Util.loadPageData(this)) { // 加载缓存数据失败，初始化页面
      this.resetSearch();
    }
  },
  methods: {
    queryList() {
      systemMessageApi.queryProclamationList(this.searchInfo).then(res => {
        this.dataList = res.records;
        this.searchInfo.totalCount = res.totalCount;
      });
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    // 撤回通知
    revoke(data) {
      systemMessageApi.revoke(data.id).then(() => {
        this.resetSearch();
      });
    },
    deleteData(data) {
      systemMessageApi.delete(data.id).then(() => {
        this.resetSearch();
      })
    }
  }
};
</script>

<style lang="scss" scoped>
</style>